import { AnimatePresence, motion } from "framer-motion"

export const Category = ({ categories, categorySeleted, setCategorySelected}) => {
    
    const handleClick = (value) => {
        return setCategorySelected(value)
    }
    
    return (
        <ul className="flex gap-10">
            {categories.map((item, index) => 
                <li key={index+1} className="relative flex items-center justify-center">
                    <motion.button 
                        whileHover={{ scale:1.045}} 
                        whileTap={{ scale:0.945}} 
                        onClick={() => handleClick(item)}

                        transition={{ type:"spring", duration:.5, ease:"easaeIn"}}
                        className={`${categorySeleted === item ? "text-orange-600" : "text-slate-300"} relative text-center`}
                    >{item} 
                    </motion.button>

                    {categorySeleted === item && 
                        <AnimatePresence initial={false}>
                            <motion.span 
                                className="bg-orange-500 w-2 h-2 rounded-full block absolute -bottom-2 transform"
                                initial={{ opacity:0, scale:.945 }}
                                animate={{ opacity:1, scale:1 }}

                                transition={{ type:"spring", stiffness:200, damping:70, ease:"easeIn"}}
                            ></motion.span>
                        </AnimatePresence>
                    }
                </li>
            )}
        </ul>
    )
}